import { espace } from "@/content/espaces.meta";

// Base URL de l'API backend.
// En l'absence de REACT_APP_BACKEND_URL (build local sans .env), on retombe sur
// un chemin relatif "/api" plutôt que sur l'URL invalide "undefined/api" qui
// provoquait des 404 dans la console.
const RAW_BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API_BASE = RAW_BACKEND_URL ? `${RAW_BACKEND_URL}/api` : "/api";

// Indique si un backend distant est réellement configuré. Permet aux composants
// non essentiels (preuve sociale, etc.) d'éviter des appels réseau inutiles.
export const HAS_BACKEND = Boolean(RAW_BACKEND_URL);

// URL de l'Edge Function publique Supabase (repo app Next.js/Supabase) qui WRAPPE
// le moteur de règles déterministe (art. 24/25/26, passerelle 25-1, échéancier) et
// la génération PDF. Le site l'appelle en fetch (pas de SDK, aucune auth/apikey).
// Surchargée par REACT_APP_RULES_FN_URL ; à défaut, on utilise l'URL publique LIVE
// (fonction déployée, sans secret) pour que les outils fonctionnent même si l'env
// n'est pas injecté au build. Si jamais elle était vidée, les outils basculeraient
// en « mode dégradé » (aperçu désactivé) — la logique de règles n'est JAMAIS réécrite ici.
export const RULES_FN_URL = (
    process.env.REACT_APP_RULES_FN_URL ||
    "https://nncayxyjjagbrqevmzjc.supabase.co/functions/v1/rules"
).replace(/\/$/, "");
export const HAS_RULES_FN = Boolean(RULES_FN_URL);

// Espaces de connexion : source UNIQUE dans content/espaces.meta.js (partagée avec les
// scripts de build). Les adresses y sont VALIDÉES : une variable de build fausse
// (REACT_APP_APP_URL / REACT_APP_MANAGER_URL) retombe sur la production au lieu
// d'envoyer les visiteurs saisir leur mot de passe sur un autre hôte.
//   - TyCopro (syndics, conseil syndical, copropriétaires) : connexion → /login · inscription → /signup ;
//   - TyCopro Manager (opérateurs, collectivités) : connexion → /login, AUCUNE inscription en ligne.
const ESPACE_APP = espace("app");
const ESPACE_MANAGER = espace("manager");

export const APP_URL = ESPACE_APP.origine;
export const APP_LOGIN_URL = ESPACE_APP.connexion;
export const APP_REGISTER_URL = ESPACE_APP.inscription;
export const MANAGER_URL = ESPACE_MANAGER.origine;
export const MANAGER_LOGIN_URL = ESPACE_MANAGER.connexion;

// La cible est l'app externe → ouverture dans un nouvel onglet.
export const APP_LINK_IS_EXTERNAL = true;

// Attributs à poser sur tout lien pointant vers l'app. Centralisés ici pour que
// les CTA « Démarrer » se comportent tous pareil, où qu'ils soient sur le site.
export const APP_LINK_PROPS = APP_LINK_IS_EXTERNAL ? { target: "_blank", rel: "noreferrer" } : {};

// Événement de conversion PostHog — no-op si l'utilisateur a refusé les cookies
// (PostHog n'est alors pas initialisé).
export function track(event, properties) {
    try {
        window.posthog?.capture?.(event, properties);
    } catch {
        // analytics ne doit jamais casser l'UX
    }
}
